import BaseProxy from './Proxy';

export default class SubstoreReturnFromExternalPartnerProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/returnFromPartner', parameters);
  }

  find(subscriptionTemplateId) {
    return this.submit('post', `${this.endpoint}/${subscriptionTemplateId}`);
  }

  returnFromExternalPartner(queryMap) {
    return this.submit('post', `${this.endpoint}`, queryMap);
  }
}
